import { Table } from 'antd';
import React, { FC, useEffect, useState } from 'react';
import { getRefundedItemsTodo } from '../../../api/refunds.api';
import useAxios from '../../../hooks/useAxios';
import config from '../../../lib/config';
import { IGetRefundedItemsTodo, IRefundedOrderTodo } from '../../../models/refunds.model';
import ErrorResponse from '../../ErrorResponse';
import Loader from '../../Loader';
import Pagination from '../../Pagination';
import ColumnsCollection from './RefundColumns';
import { adminRefundCancel } from '../../../api/niceRefunds.api';
import useNotification from '../../../hooks/useNotification';

interface IProps {
  data: IRefundedOrderTodo[] | undefined;
  doGetRefundedOrdersTodo: () => void;
}

const RefundHistory: FC<IProps> = ({
                                     data,
                                     doGetRefundedOrdersTodo,
                                   }) => {
  const { successNotification } = useNotification();
  const { data: res, isLoading, error, execute } = useAxios<IGetRefundedItemsTodo>();
  const { data: submitRes, isLoading: submitIsLoading, error: submitError, execute: submitExecute } = useAxios();
  const [Columns1, Columns2] = ColumnsCollection();

  const [page, setPage] = useState(1);
  const [refundNo, setRefundNo] = useState<number>();

  const doCancelAdminRefund = () => {
    if (refundNo) {
      submitExecute(adminRefundCancel(refundNo));
    }
  };

  useEffect(() => {
    if (refundNo) {
      execute(getRefundedItemsTodo(refundNo));
    }
  }, [refundNo]);

  useEffect(() => {
    if (submitRes) {
      doGetRefundedOrdersTodo();
      setRefundNo(undefined);
      successNotification('환불 취소가 완료되었습니다.');
    }
  }, [submitRes]);

  return (
    <>
      {isLoading ? <Loader /> : null}
      <ErrorResponse error={error} />

      <Table
        className="comm-table__area"
        columns={Columns1}
        dataSource={data}
        pagination={{
          current: page,
          pageSize: config.pageSize,
        }}
        onRow={record => {
          return {
            onClick: () => {
              setRefundNo(record.refundNo);
            },
          };
        }}
        rowClassName={(record: IRefundedOrderTodo) => record.refundNo === refundNo ? 'chosen' : 'pointer'}
        rowKey="refundNo"
      />
      <div className="comm-bx__between">
        <div className="common-paging center">
          <Pagination
            count={data?.length || 0}
            page={page}
            setPage={setPage}
          />
        </div>
      </div>
      {
        refundNo
          ? (
            <Table
              className="comm-table__area"
              columns={Columns2}
              dataSource={res?.data}
              pagination={{
                current: 1,
                pageSize: 99999,
              }}
            />
          )
          : null
      }

      {
        res?.data?.every(it => it.processMtd === '02') && (
          <div className="comm-btn__area mt-2 justify-content-end">
            <button type="button"
                    className="btn-basic pink-line"
                    onClick={doCancelAdminRefund}
            >
              환불 취소
            </button>
          </div>
        )
      }
    </>
  );
};

export default RefundHistory;
